module.exports = __webpack_public_path__ + "img/2_282.221da900.png";